import anvilTheme from "./anvilStyles";
import {createBreakpoints} from "@chakra-ui/theme-tools";

export default createBreakpoints({
    ...anvilTheme.breakpoints
});
